import { UPI_LIST_DATA, UPI_LIST_ERROR_DATA, UPI_LIST_HIDE_ERROR_DATA, UPI_LIST_START_LOADER, UPI_LIST_STOP_LOADER, } from "../interface/IUPIList";
const initialState = {
    upiList: {},
    loader: false,
    errorData: {
        error: undefined,
        isOpen: false,
    },
};
const upiListReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPI_LIST_DATA:
            return Object.assign(Object.assign({}, state), { upiList: action.payload.upiList });
        case UPI_LIST_ERROR_DATA:
            return Object.assign(Object.assign({}, state), { error: action.payload.errorData });
        case UPI_LIST_HIDE_ERROR_DATA:
            return Object.assign(Object.assign({}, state), { errorData: initialState.errorData });
        case UPI_LIST_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case UPI_LIST_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default upiListReducer;
